import { FC, ReactNode } from "react";
import appState from "../../../state/AppStateContainer";
import styles from './EmailTemplate.module.scss';
import { useTranslation, Trans } from "react-i18next";

type Props = {
  children: ReactNode
}

const EmailTemplate: FC<Props> = ({ children }) => {
  const [t] = useTranslation('email');
  return (
    <div className={styles.emailContainer}>
      <img src={appState.currentOrganization.logoURL} style={{ maxWidth: '300px', margin: '16px 0' }} />
      <section className={styles.emailContent}>
        {children}
      </section>
      <footer style={{ marginBottom: '10px' }}>
      <img src="https://cdn.prod.website-files.com/60ca0e6159e2663916316a16/67d0ef99ab5d5a6fcc0e4f66_Logos_Accurator.png" width="175" height="60" style={{ width: '175px', height: '60px' }} />
      <Trans t={t} i18nKey="footer" components={{ br: <br/>, a: <a />, em: <em/> }} />
      </footer>
    </div>
  )
}

export default EmailTemplate;
